import allReportsCard from './ChapterNavigationCard';

export default allReportsCard;
